'use strict';
import noPoster from './components/no-poster';
import sectorAccordion from './components/sector-accordion-collection';
import catList from './components/category-list';
import sectorScroll from './components/sector-scroll';

module.exports = function () {
    console.log('SECTOR');
    sectorScroll();
    noPoster();
    sectorAccordion();
    catList();

};
